import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    //mode: "dark",
    primary: {
      main: "#916DB0", // purple
    },
    secondary: {
      main: "#ED6D5A", // Red
    },
    lightGrey: {
      main: "#F8F8F8", // Light grey
    },
    darkGrey: {
      main: "#DDDDDD", // Dark grey
    },
    purple: {
      main: "#916DB0",
    },
    darkPurple: {
      main: "#724E91",
    },
    red: {
      main: "#ED6D5A",
    },
    yellow: {
      main: "#EDD16E",
    },
    pink: {
      main: "#EABFCB",
    },
    lightBlue: {
      main: "#CAF0F8",
    },
    background: {
      default: "#ffffff",
    },
    blue: {
      main: "#42c7e6",
    },
    error: {
      main: "#ff4560",
    },
  },
  typography: {
    fontFamily: '"Catamaran"',
    h1: {
      fontSize: "30px",
      fontWeight: 600,
      marginBottom: 10,
    },
    h2: {
      fontSize: "24px",
      fontWeight: 600,
      lineHeight: 1.3,
      marginBottom: 5,
    },
    h3: {
      fontSize: "24px",
      fontWeight: 500,
      marginBottom: 16,
    },
    h4: {
      fontSize: "20px",
      fontWeight: 500,
      marginTop: 16,
      marginBottom: 5,
    },
    h5: {
      fontSize: "20px",
      marginTop: 16,
      marginBottom: 5,
    },
    h6: {
      fontSize: "18px",
      marginTop: 16,
      marginBottom: 5,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          color: "white",
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiFilledInput-underline:before": {
            borderBottom: "0px solid red",
          },
          "& .MuiFilledInput-root": {
            borderRadius: 6,
          },
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          padding: 32,
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          padding: "32px 32px 16px 32px",
        },
      },
    },
    MuiDialogContentText: {
      styleOverrides: {
        root: {
          marginBottom: 16,
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: "0px 32px 32px 32px",
        },
      },
    },
  },
  spacing: 16,
});
